import { render, staticRenderFns } from "./AtMemberName.vue?vue&type=template&id=3278e652&scoped=true&"
import script from "./AtMemberName.vue?vue&type=script&lang=js&"
export * from "./AtMemberName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278e652",
  null
  
)

export default component.exports